export default {
  //系统配置表
  getConfigList: '/api/config/getConfigList',
  addConfig: '/api/config/addConfig',
  editConfig: '/api/config/editConfig',
  delConfig: '/api/config/delConfig',
  //获取sts
  getSts: '/api/alioss/getSts',
  //文件id获取文件预览链接
  getFileLibraryNewDetail: '/api/fileLibrary/getFileLibraryDetail',
  //配置oss
  addCompanyOss: '/api/alioss/addCompanyOss',
  //检查公司oss是否已配置
  checkCompanyOssExist: '/api/alioss/checkCompanyOssExist',

  /**
   * 文件库相关接口
   */
  getFileDirectoryList: '/api/fileDirectory/getFileDirectoryList',
  addFileDirectory: '/admin/file/addFileDirectory',
  editFileDirectory: '/admin/file/editFileDirectory',
  delFileDirectory: '/admin/file/delFileDirectory',

  //任务模板接口
  task_templates: '/api/task-templates',
  task_templates_add: '/api/task-templates',
  task_templates_edit: '/api/task-templates/update',
  task_templates_del: '/api/task-templates/delete',

  //任务模板方法
  task_methods: '/api/task-methods',
  task_methods_add: '/api/task-methods',
  task_methods_edit: '/api/task-methods/update',
  task_methods_del: '/api/task-methods/delete',

  //获取限行规则详情
  getTrafficRestrictionByDate: '/api/trafficRestrictionRules/getTrafficRestrictionByDate',

  //查询我发起的流程列表
  getMyInitiatedList: '/api/processInstance/getMyInitiatedList',
  //发起流程时间轴
  getTimeLine: '/api/processInstance/getTimeLine',
  //我的待办
  getMyTodoList: '/api/processInstance/getMyTodoList',
  //我处理的
  getMyHandledList: '/api/processInstance/getMyHandledList',

  //审批请假
  approveLeaveRequests: '/api/leaveRequests/approveLeaveRequests',

  //发起待办统一入口
  create: '/api/todo/create',
  //待办审批
  approve: '/api/todo/approve',
  //取消发起
  cancel: '/api/todo/cancel',
  //抄送我的
  getCopyToMeList: '/api/processInstance/getCopyToMeList',

  //文件柜相关接口
  getFileAreaList: '/api/fileArea/getFileAreaList', //查询区域信息
  getFileBoardList: '/api/fileBoard/getFileBoardList', //查询对应区域的主控
  getFileCabinetList: '/api/fileCabinet/getFileCabinetList', //查询区域对应的柜子
  openCabinet: '/api/fileCabinet/openCabinet', //开锁

  //查询短信列表
  getSmsReceiveRecordList: '/api/smsReceiveRecord/getSmsReceiveRecordList',
  //查询短信详情
  getSmsReceiveRecordDetail: '/api/smsReceiveRecord/getSmsReceiveRecordDetail',
};
